import { GetPacksRequest, GroupResource } from '@foxbun/lib-goferal-types';
import { AbstractModelStore } from './abstract/AbstractModelStore';
import { ObjectId } from 'bson';
import { action } from 'mobx';
import { GroupModel } from '../../models/GroupModel';

export class GroupStore extends AbstractModelStore<GroupModel, GroupResource> {
  @action async getGroups(req: GetPacksRequest) {
    let groups = await this.client.groups.getGroups(req).call();
    return groups.items.map((i) => {
      return this.ensureModel(i._id, i);
    });
  }

  protected generateModel(id: ObjectId, data: GroupResource | undefined): GroupModel {
    return new GroupModel({
      api_client: this.client,
      id: id,
      data: data
    });
  }

  async getProfileGroups(id: ObjectId) {
    let results = await this.client.profile.getProfileGroups({
      _id: id
    });
    return results.map((r) => {
      return this.ensureModel(r._id, r);
    });
  }
}
